import { render, staticRenderFns } from "./ModificacionDetalle.vue?vue&type=template&id=b7b9fc76"
import script from "./ModificacionDetalle.vue?vue&type=script&lang=js"
export * from "./ModificacionDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports